import React from 'react'
import { FormattedMessage } from 'react-intl'

import { WhySection, WhyHeading, WhyList, WhyItem, WhyTitle, WhyBody } from './WhyStyledComponents'

const ITEMS = [
  { title: 'homepage.why.enterprise.title', body: 'homepage.why.enterprise.body' },
  { title: 'homepage.why.checkout.title', body: 'homepage.why.checkout.body' },
  { title: 'homepage.why.standards.title', body: 'homepage.why.standards.body' }
]

const Why = () => (
  <WhySection>
    <WhyHeading>
      <FormattedMessage id="homepage.why.heading" />
    </WhyHeading>
    <WhyList>
      {ITEMS.map(item => (
        <WhyItem key={item.title}>
          <WhyTitle>
            <FormattedMessage id={item.title} />
          </WhyTitle>
          <WhyBody>
            <FormattedMessage id={item.body} />
          </WhyBody>
        </WhyItem>
      ))}
    </WhyList>
  </WhySection>
)

Why.displayName = 'Why'

export default Why
